/* eslint-disable no-unused-vars */
import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from './Modules/Login/Components/Login';
import TermsOfUse from './Modules/Login/Components/TermsOfUse';
import PrivacyPolicy from './Modules/Login/Components/PrivacyPolicy';
import Registration from './Modules/Registration/Components/Registration';
import RegistrationOptions from './Modules/Registration/Components/RegistrationOptions';
import ForgotUserID from './Modules/ResetProfile/Components/ForgotUserID';
import PasswordRecovery from './Modules/ResetProfile/Components/PasswordRecovery';
import RegistrationSuccess from './Modules/Registration/Components/RegistrationSuccess';
import Claims from './Modules/Claims/Components/Claims';
import ChangePassword from './Modules/ResetProfile/Components/ChangePassword';
import FeedBack from './Modules/FeedBackReport/Components/Feedback';
import AdminView from './Modules/Login/Components/AdminView';
import ContactUs from './Modules/ContactUs/Components/ContactUs';
import GenericNotFound from './Modules/GenericNotFound/Components/404NotFound';
import PDFViewer from './SharedModule/PDF/PDFViewer';
import SendMFACode from './Modules/MFA/Components/SendMFACode'
import ValidateOtp from './Modules/MFA/Components/ValidateOtp'

export default function RoutesApp(props) {
  return (
    <React.Fragment>
      <Switch>
      <Route exact path="/" component={Login} />
      <Route path="/login" component={Login} />
      <Route path="/adminLogin" component={AdminView} />
      <Route path="/registration" component={Registration} />
      <Route path="/registrationOptions" component={RegistrationOptions} />
      <Route path="/forgotUserID" component={ForgotUserID} />
      <Route path="/passwordRecovery" component={PasswordRecovery} /> 
      <Route path='/sendMFACode' component={SendMFACode} /> 
      <Route path='/validateOTP' component={ValidateOtp} /> 
      <Route path="/changePassword" component={ChangePassword} /> 
      <Route path="/success" component={RegistrationSuccess} />  
      <Route path='/claims' component={Claims} /> 
      <Route path='/feedback' component={FeedBack} />
      <Route path='/contactUs' component={ContactUs} />
      <Route path='/termsOfUse' component={TermsOfUse} />
      <Route path='/privacyPolicy' component={PrivacyPolicy} />
      <Route path='/Help' component={PDFViewer} />
      <Route path='*' exact={true} component={GenericNotFound} />
      </Switch>
    </React.Fragment>
  );
}
